import { Injectable } from '@angular/core';

/**
 * Generated class for the FamilyPage page.
 *
 * See http://ionicframework.com/docs/components/#navigation for more info
 * on Ionic pages and navigation.
 */

@Injectable()
export class ChildAction {

  constructor(
  	) {
  }

  /**
   * 月齢を算出する
   */
  calcChildOfAge(birthday:Date, resereveDate:Date = new Date()):any{

		var mybirth_y = birthday.getFullYear();
		var mybirth_m = birthday.getMonth() + 1;
		var mybirth_d = birthday.getDate();

		// その他変数(※編集の必要はありません)
		var age_y = -1;
		var age_m = -1;
		// var now = new Date();
		var now = resereveDate;
		var now_y = now.getFullYear(); if(now_y < 1900) now_y += 1900;
		var now_m = now.getMonth() + 1;
		var now_d = now.getDate();

		// 年齢の算出
		if(now_m > mybirth_m) age_y = now_y - mybirth_y;
		if(now_m == mybirth_m && now_d >= mybirth_d) age_y = now_y - mybirth_y;
		if(age_y == -1) age_y = now_y - mybirth_y - 1;

		// ○ヶ月目の算出
		if(now_m < mybirth_m) now_m += 12;
		if(now_m == mybirth_m && now_d < mybirth_d) now_m += 12;
		if(now_d >= mybirth_d ) now_m += 1;
		age_m = now_m - mybirth_m;

		if (age_m > 0){
			age_m = age_m - 1;
		} else {
			if (age_y > 0){
				age_y = age_y - 1;
				age_m = 12;
			}
		}
    return [age_y, age_m];
	}
}


// WEBPACK FOOTER //
// ./src/actions/child.action.ts